import React, { useState, useEffect, useRef } from "react";
import moment from "moment";
import Alert from "react-bootstrap/Alert";
import { Button, Modal } from "react-bootstrap";
import InputLebelComponent from "../../../InputLebel/InputLebelComponent";
import { AlertDanger, AlertSuccess } from "../../../Alerts/Alert";
import saveEducationDetails from "../../../../apis/saveEducationDetails";
import removeEducationDetails from "../../../../apis/removeEducationDetails";
import getEducationDetails from "../../../../apis/getEducationDetails";
import updateEducationDetails from "../../../../apis/updateEducationDetails";

import Swal from "sweetalert2";
import swalWithBootstrapButtons from "sweetalert2-react-content";
import { useAuthContext } from "../../../../context/AuthContext";
import { toast } from "react-toastify";

const Education = (props) => {
  const statusRef = useRef(null);
  const executeScroll = () => statusRef.current.scrollIntoView();

  const { educationDetails, resourceSlug } = props;
  const [educationArray, setEducationArray] = useState(false);
  const { userDetails } = useAuthContext();
  const current_user_slug = JSON.parse(userDetails).user_slug;

  const MySwal = swalWithBootstrapButtons(Swal);

  const [show, setShow] = useState(false);
  const [showEdit, setShowEdit] = useState(false);

  const [degreeName, setDegreeName] = useState("");
  const [subject, setSubject] = useState("");
  const [schoolName, setSchoolName] = useState("");
  const [passedOn, setPassedOn] = useState("");
  const [educationId, setEducationId] = useState(false);

  const [buttonText, setButtonText] = useState("Save Education Details");
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [hasSubmitError, setHasSubmitError] = useState(false);
  const [isValidSubmit, setIsValidSubmit] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [successMessage, setSuccessMessage] = useState(false);

  const handleShow = () => setShow(true);

  const handleClose = () => {
    setShow(false);
    window.location.reload(false);
  };

  useEffect(() => {
    if (educationDetails) {
      const sortedDetails = educationDetails.sort((a, b) => {
        const date1 = moment(a?.passed_on, "MM-DD-YYYY");
        const date2 = moment(b?.passed_on, "MM-DD-YYYY");
        return date2 - date1;
      });
      setEducationArray(sortedDetails);
    }
  }, [educationDetails]);

  const handleFormSubmit = () => {
    //disable signup button
    setIsButtonDisabled(true);

    //change signup button text while processing
    setButtonText("Processing, please wait...");

    //change alert block content
    setHasSubmitError(false);
    setErrorMessage(false);
    setIsValidSubmit(false);
    setSuccessMessage(false);

    let isInvalid = 0;
    let errMessage = [];

    if (degreeName.trim().length === 0) {
      isInvalid = 1;
      errMessage.push("Enter your document name");
    }

    if (subject.trim().length === 0) {
      isInvalid = 1;
      errMessage.push("Enter your subject name");
    }

    if (schoolName.trim().length === 0) {
      isInvalid = 1;
      errMessage.push("Enter your school name");
    }

    if (!moment(passedOn, "YYYY-MM-DD").isValid()) {
      isInvalid = 1;
      errMessage.push("Enter your passing year");
    }

    if (isInvalid === 1) {
      executeScroll();
      setErrorMessage(errMessage);
      setHasSubmitError(true);
      setIsButtonDisabled(false);
      setButtonText("Save Education Details");
    } else {
      submitForm();
    }
  };

  const submitForm = () => {
    let errMessage = [];
    let succMessage = [];

    let formData = {
      current_user_slug: current_user_slug,
      resourceSlug: resourceSlug,
      degreeName: degreeName,
      subject: subject,
      schoolName: schoolName,
      passedOn: passedOn,
    };

    try {
      saveEducationDetails(formData).then(async (data) => {
        if (data?.data) {
          if (data.data.status === 1) {
            succMessage.push(data.data.message);
            setSuccessMessage(succMessage);
            setIsValidSubmit(true);
            setHasSubmitError(false);
            setButtonText("Save Education Details");
            executeScroll();
            setTimeout(() => {
              setIsValidSubmit(false);
              setHasSubmitError(false);
              setErrorMessage(false);
              setSuccessMessage(false);
              window.location.reload(false);
            }, 1000);
          } else if (data.data.status === 0) {
            executeScroll();
            errMessage.push(data.data.message);
            setErrorMessage(errMessage);
            setHasSubmitError(true);
            setIsButtonDisabled(false);
            setButtonText("Save Education Details");
          } else {
            executeScroll();
            errMessage.push(
              "Error happened. Unable to save education information."
            );
            setErrorMessage(errMessage);
            setHasSubmitError(true);
            setIsButtonDisabled(false);
            setButtonText("Save Education Details");
          }
        } else {
          executeScroll();
          errMessage.push(
            "Error happened. Unable to save education information."
          );
          setErrorMessage(errMessage);
          setHasSubmitError(true);
          setIsButtonDisabled(false);
          setButtonText("Save Education Details");
        }
      });
    } catch (error) {
      executeScroll();
      errMessage.push("Error happened. Network error happened.");
      setErrorMessage(errMessage);
      setHasSubmitError(true);
      setIsButtonDisabled(false);
      setButtonText("Save Education Details");
    }
  };

  const handleEditEducation = (id) => {
    let formData = {
      resourceSlug: resourceSlug,
      id: id,
    };

    try {
      getEducationDetails(formData).then(async (data) => {
        if (data?.data) {
          if (data.data.status === 1) {
            await setDegreeName(data.data.education_details.degree_name);
            await setSchoolName(data.data.education_details.school_name);
            await setSubject(data.data.education_details.subject);
            await setPassedOn(data.data.education_details.passed_on);
            await setEducationId(
              data.data.education_details.education_history_id
            );
            await setShowEdit(true);
          } else {
            await MySwal.fire({
              title: <strong>Error</strong>,
              html: <i>{data.data.message}</i>,
              icon: "danger",
            });
          }
        } else {
          await MySwal.fire({
            title: <strong>Error</strong>,
            html: <i>{data.data.message}</i>,
            icon: "danger",
          });
        }
      });
    } catch (error) {
      MySwal.fire({
        title: <strong>Success</strong>,
        html: <i>Something wrong happened!</i>,
        icon: "danger",
      });

      setIsButtonDisabled(false);
    }
  };

  const handleRemoveEducation = async (id) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "that you want to remove this education record",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, remove!",
      cancelButtonText: "Cancel",
      reverseButtons: true,
      confirmButtonColor: "var(--danger)",
      cancelButtonColor: "var(--black)",
    }).then(async (result) => {
      if (result.isConfirmed) {
        removeSelectedDetails(id);
      } else {
        await setIsButtonDisabled(false);
      }
    });
  };

  const removeSelectedDetails = (id) => {
    let formData = {
      resourceSlug: resourceSlug,
      id: id,
    };

    try {
      removeEducationDetails(formData).then(async (data) => {
        if (data?.data) {
          if (data.data.status === 1) {
            setEducationArray(
              educationArray.filter((item) => item.education_history_id !== id)
            );
          } else if (data.data.status === 0) {
            await MySwal.fire({
              title: <strong>Success</strong>,
              html: <i>{data.data.message}</i>,
              icon: "danger",
            });

            await setIsButtonDisabled(false);
          } else {
            await MySwal.fire({
              title: <strong>Success</strong>,
              html: <i>{data.data.status}</i>,
              icon: "danger",
            });

            await setIsButtonDisabled(false);
          }
        } else {
          await MySwal.fire({
            title: <strong>Success</strong>,
            html: <i>{data.data.message}</i>,
            icon: "danger",
          });

          await setIsButtonDisabled(false);
        }
      });
    } catch (error) {
      MySwal.fire({
        title: <strong>Success</strong>,
        html: <i>Something wrong happened!</i>,
        icon: "danger",
      });

      setIsButtonDisabled(false);
    }
  };

  const displayEducationHistory = () => {
    if (educationArray) {
      return (
        <>
          {educationArray.map((item, index) => {
            return displayEducationBlock(item, index);
          })}
        </>
      );
    } else {
      return (
        <Alert key={"info"} variant={"info"}>
          Education details not available!
        </Alert>
      );
    }
  };

  const displayDegreeName = (education) => {
    return (
      <span className="fw-bold">
        {education.degree_name !== null ? (
          <span className="text-success-custom">{education.degree_name}</span>
        ) : (
          "Not available"
        )}{" "}
        in {education.subject !== null ? education.subject : "Not available"}
      </span>
    );
  };

  const displaySchoolName = (education) => {
    if (education.school_name !== "" && education.school_name !== null) {
      return (
        <span className="text-info-custom fw-medium-custom">
          {education.school_name}
        </span>
      );
    } else {
      return (
        <span className="text-muted-custom fw-medium-custom">
          Institute name not available
        </span>
      );
    }
  };

  const displayPassedOn = (passedOn) => {
    if (passedOn !== "" && passedOn !== null) {
      return <span className="fw-medium-custom">Achieved {passedOn}</span>;
    }
  };

  const displayEducationBlock = (education, key) => {
    return (
      <div key={key} className="col-12 mb-3">
        <div className="card-custom">
          <div className="card-body">
            <div className="d-block d-md-flex d-xl-flex d-lg-flex row align-items-center">
              {displayDegreeName(education)}
            </div>
            <div className="d-block d-md-flex d-xl-flex d-lg-flex row align-items-center">
              {displaySchoolName(education)}
            </div>

            <div className="d-block d-md-flex d-xl-flex d-lg-flex row align-items-center mt-2">
              {displayPassedOn(education.passed_on)}
            </div>
            <div className="d-flex justify-content-end">
              <Button
                variant="success"
                disabled={isButtonDisabled}
                onClick={() =>
                  handleEditEducation(education.education_history_id)
                }
                size="sm"
                className="me-3"
              >
                Edit Item
              </Button>
              <Button
                variant="danger"
                disabled={isButtonDisabled}
                onClick={() =>
                  handleRemoveEducation(education.education_history_id)
                }
                size="sm"
              >
                Remove
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const displayAddEducationButton = () => {
    return (
      <div className="d-block justify-content-end">
        <Button variant="primary" size="sm" onClick={() => handleShow()}>
          Add New Education
        </Button>
      </div>
    );
  };

  const handleDegreeNameChange = (e) => {
    setDegreeName(e.target.value);
  };

  const handleSubjectChange = (e) => {
    setSubject(e.target.value);
  };

  const handleSchoolNameChange = (e) => {
    setSchoolName(e.target.value);
  };

  const handlePassedOnChange = (e) => {
    setPassedOn(e.target.value);
  };

  const showModal = () => {
    return (
      <Modal
        show={show}
        onHide={() => handleClose()}
        scrollable={true}
        backdrop="static"
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header>
          <div className="d-block">
            <div className="d-block">
              <span className="h5 fw-bold-custom">
                Add your education details
              </span>
            </div>
            <div className="d-block">
              <span className="text-muted-custom text-sm-custom">
                Please complete this form to save your education details
              </span>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <form id="create-frm">
            <div className="d-block mb-4">
              <div className="d-block d-md-flex d-lg-flex d-xl-flex row">
                <div className="col-12 col-md-6 col-lg-6 col-xlg-6">
                  <div className="form-input-holder">
                    <InputLebelComponent title="Designation to add" />
                    <div className="d-block">
                      <input
                        type="text"
                        className="form-control"
                        id="degree-name"
                        placeholder="Enter designation name"
                        onChange={handleDegreeNameChange}
                        value={degreeName}
                        autoComplete="off"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-6 col-xlg-6">
                  <div className="form-input-holder">
                    <InputLebelComponent title="Subject" />
                    <div className="d-block">
                      <input
                        type="text"
                        className="form-control"
                        id="subject"
                        placeholder="Enter your subject"
                        onChange={handleSubjectChange}
                        value={subject}
                        autoComplete="off"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-block d-md-flex d-lg-flex d-xl-flex row">
                <div className="col-12 col-md-6 col-lg-6 col-xlg-6">
                  <div className="form-input-holder">
                    <InputLebelComponent title="Institute Name" />
                    <div className="d-block">
                      <div className="d-block">
                        <input
                          type="text"
                          className="form-control"
                          id="school"
                          placeholder="Enter school name"
                          onChange={handleSchoolNameChange}
                          value={schoolName}
                          autoComplete="off"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-6 col-xlg-6">
                  <div className="form-input-holder">
                    <InputLebelComponent title="Achieved" />
                    <div className="d-block">
                      <div className="d-block">
                        <input
                          type="date"
                          className="form-control"
                          id="passed-on"
                          placeholder="Enter date obtained"
                          onChange={handlePassedOnChange}
                          value={passedOn}
                          autoComplete="off"
                          onKeyDown={(e) => {
                            e.preventDefault();
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-end">
              {displayCloseButton()}
              {displaySubmitButton()}
            </div>

            <div className="d-block" ref={statusRef}>
              {displayStatusMessage()}
            </div>
          </form>
        </Modal.Body>
      </Modal>
    );
  };

  const displaySubmitButton = () => {
    return (
      <div className="d-block">
        <Button
          variant="primary"
          disabled={isButtonDisabled}
          onClick={handleFormSubmit}
          size="sm"
        >
          {buttonText}
        </Button>
      </div>
    );
  };

  const displayCloseButton = () => {
    return (
      <div className="d-block me-3">
        <Button
          variant="dark"
          disabled={isButtonDisabled}
          onClick={() => closeAddModal()}
          size="sm"
        >
          Close
        </Button>
      </div>
    );
  };

  const closeAddModal = () => {
    setShow(false);
    setDegreeName("");
    setSubject("");
    setSchoolName("");
    setPassedOn(false);

    setHasSubmitError(false);
    setIsValidSubmit(false);
    setErrorMessage(false);
    setSuccessMessage(false);
  };

  const handleFormUpdate = () => {
    //disable signup button
    setIsButtonDisabled(true);

    //change signup button text while processing
    setButtonText("Processing, please wait...");

    //change alert block content
    setHasSubmitError(false);
    setErrorMessage(false);
    setIsValidSubmit(false);
    setSuccessMessage(false);

    let isInvalid = 0;
    let errMessage = [];

    if (degreeName !== null) {
      if (degreeName.trim().length === 0) {
        isInvalid = 1;
        errMessage.push("Enter your designation name");
      }
    } else {
      isInvalid = 1;
      errMessage.push("Enter your designation name");
    }

    if (subject !== null) {
      if (subject.trim().length === 0) {
        isInvalid = 1;
        errMessage.push("Enter your subject name");
      }
    } else {
      isInvalid = 1;
      errMessage.push("Enter your subject name");
    }

    if (schoolName !== null) {
      if (schoolName.trim().length === 0) {
        isInvalid = 1;
        errMessage.push("Enter your school name");
      }
    } else {
      isInvalid = 1;
      errMessage.push("Enter your school name");
    }

    if (passedOn !== null) {
      if (!moment(passedOn, "YYYY-MM-DD").isValid()) {
        isInvalid = 1;
        errMessage.push("Enter your passing year");
      }
    } else {
      isInvalid = 1;
      errMessage.push("Enter your passing year");
    }

    if (isInvalid === 1) {
      executeScroll();
      setErrorMessage(errMessage);
      setHasSubmitError(true);
      setIsButtonDisabled(false);
      setButtonText("Save Education Details");
    } else {
      updateForm();
    }
  };

  const updateForm = () => {
    let errMessage = [];
    let succMessage = [];

    let formData = {
      current_user_slug: current_user_slug,
      educationId: educationId,
      resourceSlug: resourceSlug,
      degreeName: degreeName,
      subject: subject,
      schoolName: schoolName,
      passedOn: passedOn,
    };

    try {
      updateEducationDetails(formData).then(async (data) => {
        if (data?.data) {
          if (data.data.status === 1) {
            const updatedEducation = data.data.result; // assuming this is the returned updated item
            setEducationArray((prev) => {
              const updatedArray = prev.map((item) =>
                item.education_history_id ===
                updatedEducation.education_history_id
                  ? updatedEducation
                  : item
              );

              // Optional: sort after update
              return updatedArray.sort(
                (a, b) =>
                  moment(b.passed_on, "MM-DD-YYYY") -
                  moment(a.passed_on, "MM-DD-YYYY")
              );
            });
            handleCloseEditModal();
            setIsButtonDisabled(false);
            setButtonText("Processing, please wait...");
            setIsValidSubmit(false);
            setSuccessMessage(false);
            toast.success(data.data.message);
            setHasSubmitError(false);
            setButtonText("Save Education Details");
            executeScroll();
            setIsValidSubmit(false);
            setHasSubmitError(false);
            setErrorMessage(false);
          } else if (data.data.status === 0) {
            executeScroll();
            errMessage.push(data.data.message);
            setErrorMessage(errMessage);
            setHasSubmitError(true);
            setIsButtonDisabled(false);
            setButtonText("Save Education Details");
          } else {
            executeScroll();
            errMessage.push(
              "Error happened. Unable to update education information."
            );
            setErrorMessage(errMessage);
            setHasSubmitError(true);
            setIsButtonDisabled(false);
            setButtonText("Save Education Details");
          }
        } else {
          executeScroll();
          errMessage.push(
            "Error happened. Unable to update education information."
          );
          setErrorMessage(errMessage);
          setHasSubmitError(true);
          setIsButtonDisabled(false);
          setButtonText("Save Education Details");
        }
      });
    } catch (error) {
      executeScroll();
      errMessage.push("Error happened. Network error happened.");
      setErrorMessage(errMessage);
      setHasSubmitError(true);
      setIsButtonDisabled(false);
      setButtonText("Save Education Details");
    }
  };

  const displayStatusMessage = () => {
    return (
      <>
        {displayErrorMessage()} {displaySuccessMessage()}
      </>
    );
  };

  const displayErrorMessage = () => {
    if (hasSubmitError) {
      return (
        <div className="d-block mt-4">
          <AlertDanger title={"Oops"} message={errorMessage} />
        </div>
      );
    }
  };

  const displaySuccessMessage = () => {
    if (isValidSubmit) {
      return (
        <div className="d-block mt-4">
          <AlertSuccess title={"Success"} message={successMessage} />
        </div>
      );
    }
  };

  //EDIT SECTION --------------------------------------------------------

  const handleCloseEditModal = async () => {
    await setDegreeName("");
    await setSchoolName("");
    await setSubject("");
    await setPassedOn("");
    await setEducationId(false);
    await setShowEdit(false);
  };

  const showEditModal = () => {
    return (
      <Modal
        show={showEdit}
        onHide={() => handleCloseEditModal()}
        scrollable={true}
        backdrop="static"
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header>
          <div className="d-block">
            <div className="d-block">
              <span className="h5 fw-bold-custom">Edit education details</span>
            </div>
            <div className="d-block">
              <span className="text-muted-custom text-sm-custom">
                Please complete this form to save your education details
              </span>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <form id="edit-frm">
            <div className="d-block mb-4">
              <div className="d-block d-md-flex d-lg-flex d-xl-flex row">
                <div className="col-12 col-md-6 col-lg-6 col-xlg-6">
                  <div className="form-input-holder">
                    <InputLebelComponent title="Designation to add" />
                    <div className="d-block">
                      <input
                        type="text"
                        className="form-control"
                        id="degree-name-edit"
                        placeholder="Enter designation name"
                        onChange={handleDegreeNameChange}
                        value={degreeName}
                        autoComplete="off"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-6 col-xlg-6">
                  <div className="form-input-holder">
                    <InputLebelComponent title="Subject" />
                    <div className="d-block">
                      <input
                        type="text"
                        className="form-control"
                        id="subject-edit"
                        placeholder="Enter your subject"
                        onChange={handleSubjectChange}
                        value={subject}
                        autoComplete="off"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-block d-md-flex d-lg-flex d-xl-flex row">
                <div className="col-12 col-md-6 col-lg-6 col-xlg-6">
                  <div className="form-input-holder">
                    <InputLebelComponent title="Institute Name" />
                    <div className="d-block">
                      <div className="d-block">
                        <input
                          type="text"
                          className="form-control"
                          id="school-edit"
                          placeholder="Enter your school name"
                          onChange={handleSchoolNameChange}
                          value={schoolName}
                          autoComplete="off"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-6 col-xlg-6">
                  <div className="form-input-holder">
                    <InputLebelComponent title="Achieved" />
                    <div className="d-block">
                      <div className="d-block">
                        <input
                          type="date"
                          className="form-control"
                          id="passed-on-edit"
                          placeholder="Enter date obtained"
                          onChange={handlePassedOnChange}
                          value={passedOn}
                          autoComplete="off"
                          onKeyDown={(e) => {
                            e.preventDefault();
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="d-flex justify-content-end">
              {displayEditModalCloseButton()}
              {displayEditModalSubmitButton()}
            </div>

            <div className="d-block" ref={statusRef}>
              {displayStatusMessage()}
            </div>
          </form>
        </Modal.Body>
      </Modal>
    );
  };

  const displayEditModalSubmitButton = () => {
    return (
      <div className="d-block">
        <Button
          variant="primary"
          disabled={isButtonDisabled}
          onClick={handleFormUpdate}
          size="sm"
        >
          {buttonText}
        </Button>
      </div>
    );
  };

  const displayEditModalCloseButton = () => {
    return (
      <div className="d-block me-3">
        <Button
          variant="dark"
          disabled={isButtonDisabled}
          onClick={() => handleCloseEditModal()}
          size="sm"
        >
          Close
        </Button>
      </div>
    );
  };

  return (
    <div className="d-block">
      <div className="d-flex mb-2 justify-content-end">
        {displayAddEducationButton()}
      </div>
      {displayEducationHistory()}
      {showModal()}
      {showEditModal()}
    </div>
  );
};

export default Education;
